import React from 'react';
import { ReportWidgetLoader } from '../ReportWidgetLoader';
import TrendCard from '@src/components/features/reports-and-logs/executive-summary/widgets/TrendCard/TrendCard';
import { getTrendDateLabel } from '@src/utils/datesUtils';
import { BaseWidgetProps } from '@src/components/features/reports-and-logs/executive-summary/widgets/types';
import { TryAgainWidgetMessage } from '@src/components/shared/try-again-message/try-again-widget-message';

const BlockedSessionsTrendCard: React.FC<BaseWidgetProps> = (props) => (
  <ReportWidgetLoader hookProps={{ ...props, reportName: 'blockedSessions' }}>
    {(data, error) => (
      error ? <TryAgainWidgetMessage /> : <TrendCard
        total={data.total}
        title="Blocked sessions"
        trendPercent={data.trendPercent}
        trendLabel={getTrendDateLabel(props.fromDate, props.toDate)}
        trendColor="#007AE2"
        data={data.data}
        ratePercent={data.ratePercent}
      />
    )}
  </ReportWidgetLoader>
);

export default BlockedSessionsTrendCard;
